import { render, staticRenderFns } from "./ValidateStoredCard.vue?vue&type=template&id=ddf22808&scoped=true"
import script from "./ValidateStoredCard.vue?vue&type=script&lang=js"
export * from "./ValidateStoredCard.vue?vue&type=script&lang=js"
import style0 from "./ValidateStoredCard.vue?vue&type=style&index=0&id=ddf22808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf22808",
  null
  
)

export default component.exports